module.exports = __webpack_public_path__ + "71e6e32d5d7d33329420a6a4063b7bbc.png";